import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/themes/lara-light-teal/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './theme.css';
import { App } from './App';
import { applyBrand } from './brand';

applyBrand();

// Mock mode (`VITE_MOCK=true npm run dev`): the portal runs against the in-memory API used by its tests,
// handy for looking at every page with realistic data and no server.
if (import.meta.env.VITE_MOCK === 'true') {
  const [{ axiosInstance }, { installMockServer }] = await Promise.all([import('./services/api'), import('./mocks/mock-server')]);
  installMockServer(axiosInstance);
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PrimeReactProvider value={{ ripple: false }}>
      <App />
    </PrimeReactProvider>
  </StrictMode>,
);
